module.exports = "assets/21bb9d539bb91dd521801a281279218a.jpg";